import { booleanAttribute, Component, inject, input, output } from '@angular/core'

import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { AiTextGeneratorModalComponent, AiTextGeneratorConfig } from './ai-text-generator-modal.component'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { IconName } from '@fortawesome/free-solid-svg-icons'

@Component({
    selector: 'sf-ai-text-generator-button',
    standalone: true,
    imports: [FontAwesomeModule, NgbTooltipModule],
    templateUrl: './ai-text-generator-button.component.html',
    styleUrls: ['./ai-text-generator-button.component.scss'],
    host: {
        '[class.sf-compact-ai-button]': 'compact() && !useContainer()',
    },
})
export class AiTextGeneratorButtonComponent {
    #modalService = inject(NgbModal)

    // Inputs
    useContainer = input<boolean>(true)
    label = input<string>('')
    icon = input<IconName>('wand-magic-sparkles')
    size = input<'sm' | 'md' | 'lg'>('md')
    compact = input(false, { transform: booleanAttribute })
    tooltip = input<string>('Generate with AI')
    placeholder = input<string>()
    title = input<string>()
    maxLength = input<number>(500)

    instructions = input<string | undefined>(undefined)
    initialPrompt = input<string>()

    // Output
    textGenerated = output<string>()

    openModal() {
        const modalRef = this.#modalService.open(AiTextGeneratorModalComponent, {
            size: 'xl',
            centered: true,
            backdrop: 'static',
            scrollable: true,
        })

        const config: AiTextGeneratorConfig = {
            instructions: this.instructions(),
            placeholder: this.placeholder(),
            title: this.title(),
            maxLength: this.maxLength(),
            initialPrompt: this.initialPrompt(),
        }

        modalRef.componentInstance.config = config

        modalRef.result.then(
            (generatedText: string) => {
                this.textGenerated.emit(generatedText)
            },
            () => {
                // Modal dismissed
            }
        )
    }
}
